import React, { ReactNode } from 'react';
import clsx from 'clsx';
import PageTitleWithTooltip from '../common/PageTitleWithTooltip';
import styles from '../../styles/layout/MainContent.module.scss';

interface MainContentProps {
  pageTitle: string;
  pageDescription?: string;
  pageActions?: ReactNode;
  isSidebarCollapsed: boolean;
  onToggleMobileSidebar: () => void;
  children: ReactNode;
}

function MainContent({ 
  pageTitle, 
  pageDescription,
  pageActions, 
  isSidebarCollapsed, 
  onToggleMobileSidebar, 
  children 
}: MainContentProps) {
  return (
    <main className={clsx(
      styles.mainContent,
      'enterprise-main-content',
      {
        [styles.sidebarCollapsed]: isSidebarCollapsed
      }
    )}>
      {/* Page Header */}
      <header className={styles.pageHeader}>
        <div className={styles.pageHeaderContent}>
          <div className={styles.pageHeaderLeft}>
            {/* Mobile menu button */}
            <button
              className={styles.mobileMenuButton}
              onClick={onToggleMobileSidebar}
              aria-label="Open navigation menu"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
            
            <PageTitleWithTooltip 
              title={pageTitle} 
              description={pageDescription}
              className={styles.pageTitle} 
            />
          </div>
          
          {pageActions && (
            <div className={styles.pageActions}>
              {pageActions}
            </div>
          )}
        </div>
      </header>

      {/* Page Content */}
      <div className={styles.pageContent}>
        {children}
      </div>
    </main>
  );
}

export default MainContent;
